import React from 'react';
import ListItem from '../component/ListItem';
import { Row, Divider, Alert, Empty } from 'antd';
import QueueAnim from 'rc-queue-anim';

var months = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

const List = (props) => {

    const renderList = () => {
        if (props.list.length === 0) {
            return (
                <div >
                    <Empty />
                </div>
            )
        } else {
            return (<>
                <QueueAnim duration={1000} delay={300}>
                    {props.list.map((data, i) => {
                        return (
                            <div key={i}>

                                <Divider orientation="left">{data.date.length === 7 ? `${months[data.date.substring(0, 2) - 1]} ${data.date.substring(3, 7)}` : `${months[data.date.charAt(0) - 1]} ${data.date.substring(2, 6)}`}</Divider>
                                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                    {data.data.map((item, i) => {
                                        return <QueueAnim duration={1000} delay={600} key={i}><div key={i}><ListItem data={item} /></div></QueueAnim>
                                    })}
                                </Row>
                            </div>
                        )
                    })}
                </QueueAnim>
            </>
            )
        }
    }
    return (
        <div style={{ padding: 20 }}>
            <div style={{ paddingTop: '10px' }}>
                {!props.loading && props.list && renderList()}
            </div>
            {!props.loading && props.errorMsg && <Alert
                message={`Error ${props.errorMsg.code}`}
                description={props.errorMsg.msg}
                type="error"
                showIcon
            />}
        </div>
    )
}

export default List;